import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { FatturePort } from "./fatture.port";
import {
  Fattura,
  FattureQueryParams,
  ImportFattureRequestDto, ImportFattureResponseDto,
  LottoPassivoSummaryDto,
  PaginatedResponse
} from "../../models/fatture.model";
import { environment } from "../../../environments/environment";
import {TenantService} from '../tenant.service';

@Injectable({ providedIn: 'root' })
export class FattureHttpService implements FatturePort {
    private http = inject(HttpClient);
  private tenantService = inject(TenantService);
    private base = `${environment.apiBaseUrl || ''}/${this.tenantService.tenant}/fatture`;

    getList(queryParams?: FattureQueryParams): Observable<PaginatedResponse<Fattura>> {
        let params = new HttpParams();

        if (queryParams) {
            if (queryParams.size != null)       params = params.set('size', queryParams.size.toString());
            if (queryParams.page != null)       params = params.set('page', queryParams.page.toString());
            if (queryParams.wordSearch)         params = params.set('wordSearch', queryParams.wordSearch);
            if (queryParams.statoAssociazione)              params = params.set('statoAssociazione', queryParams.statoAssociazione);
           if (queryParams.statoFiscale)              params = params.set('statoFiscale', queryParams.statoFiscale);
           if (queryParams.idCantiere != null) params = params.set('idCantiere', queryParams.idCantiere.toString());
            if (queryParams.idFornitore != null) params = params.set('idFornitore', queryParams.idFornitore.toString());
            if (queryParams.tipo)               params = params.set('tipo', queryParams.tipo);
            if (queryParams.mese)               params = params.set('mese', queryParams.mese);

            if (Array.isArray(queryParams.sort) && queryParams.sort.length) {
                queryParams.sort.forEach(s => {
                    const v = (s ?? '').trim();
                    if (!v) return;
                    params = params.append('sort', v);
                });
            }
        }

        return this.http.get<PaginatedResponse<Fattura>>(this.base, { params });
    }

    getById(id: number): Observable<Fattura> {
        return this.http.get<Fattura>(`${this.base}/${id}`);
    }

  importXml(file: File): Observable<void> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<void>(`${this.base}/importXml`, formData);
  }

  setStatoFiscale(id: number, statoFiscale: string): Observable<void> {
    return this.http.patch<void>(
      `${this.base}/${id}/statoFiscale/${statoFiscale}`,
      {}
    );
  }

  setAsCostoFisso(id: number): Observable<void> {
    return this.http.patch<void>(`${this.base}/${id}/setAsCostoFisso`, {});
  }

  associateFornitore(id: number, idFornitore: number): Observable<void> {
    return this.http.patch<void>(
      `${this.base}/${id}/associateFornitore/${idFornitore}`,
      {}
    );
  }

  endFornitoreAssociation(id: number): Observable<void> {
    return this.http.patch<void>(
      `${this.base}/${id}/endFornitoreAssociation`,
      {}
    );
  }

  associateCantiere(id: number, idCantiere: number): Observable<void> {
    return this.http.patch<void>(
      `${this.base}/${id}/associateCantiere/${idCantiere}`,
      {}
    );
  }

  endCantiereAssociation(id: number): Observable<void> {
    return this.http.patch<void>(
      `${this.base}/${id}/endCantiereAssociation`,
      {}
    );
  }

  associateArticoloCantiere(idArticolo: number, idCantiere: number): Observable<void> {
    return this.http.patch<void>(
      `${this.base}/associateCantiere/${idCantiere}/toArticolo/${idArticolo}`,
      {}
    );
  }

  endArticoloCantiereAssociation(idArticolo: number): Observable<void> {
    return this.http.patch<void>(
      `${this.base}/endArticoloCantiereAssociation/${idArticolo}`,
      {}
    );
  }

  private fatturazioneBase = `${environment.apiBaseUrl || ''}/${this.tenantService.tenant}/fatturazione`;

  getLottiSdiToImport(year: number): Observable<LottoPassivoSummaryDto[]> {
    return this.http.get<LottoPassivoSummaryDto[]>(
      `${this.fatturazioneBase}/toImport/${year}`
    );
  }

  importLottiSdi(
    request: ImportFattureRequestDto
  ): Observable<ImportFattureResponseDto> {
    return this.http.post<ImportFattureResponseDto>(
      `${this.fatturazioneBase}/import`,
      request
    );
  }

  downloadOriginalFile(fileId: number): Observable<Blob> {
    return this.http.get(`${environment.apiBaseUrl || ''}/${this.tenantService.tenant}/files/${fileId}/preview`, {
      responseType: 'blob',
    });
  }
}
